import { SharedCarModule } from './../shared-car.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarOptionsShortComponent } from './car-options-short.component';

@NgModule({
  imports: [
    CommonModule,
    SharedCarModule
  ],
  declarations: [
    CarOptionsShortComponent
  ],
  exports: [
    CarOptionsShortComponent
  ]
})
export class CarOptionsShortModule { }
